<template>
  <va-create-layout>
    <medical-insurances-form :title="title" :item="item"></medical-insurances-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
